module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("处理中心")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("我的工作台")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-1"
    }
  }, [_vm._v("选项1")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-2"
    }
  }, [_vm._v("选项2")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-3"
    }
  }, [_vm._v("选项3")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ele.me",
      "target": "_blank"
    }
  }, [_vm._v("订单管理")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex2,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("处理中心")]), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n 我的工作台\n")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-1"
    }
  }, [_vm._v("选项1")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-2"
    }
  }, [_vm._v("选项2")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2-3"
    }
  }, [_vm._v("选项3")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ele.me",
      "target": "_blank"
    }
  }, [_vm._v("订单管理")])])], 1), _vm._v(" "), _c('el-button', [_vm._v("默认按钮")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("主要按钮")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("文字按钮")]), _vm._v(" "), [_c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio),
      expression: "radio"
    }],
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    domProps: {
      "value": (_vm.radio)
    },
    on: {
      "input": function($event) {
        _vm.radio = $event
      }
    }
  }, [_vm._v("\n    备选项")]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.radio),
      expression: "radio"
    }],
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    domProps: {
      "value": (_vm.radio)
    },
    on: {
      "input": function($event) {
        _vm.radio = $event
      }
    }
  }, [_vm._v("备选项")])], _vm._v(" "), [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkList),
      expression: "checkList"
    }],
    domProps: {
      "value": (_vm.checkList)
    },
    on: {
      "input": function($event) {
        _vm.checkList = $event
      }
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "复选框 A"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "复选框 B"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "复选框 C"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "禁用",
      "disabled": ""
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "选中且禁用",
      "disabled": ""
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input5),
      expression: "input5"
    }],
    attrs: {
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.input5)
    },
    on: {
      "input": function($event) {
        _vm.input5 = $event
      }
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select),
      expression: "select"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.select)
    },
    on: {
      "input": function($event) {
        _vm.select = $event
      }
    },
    slot: "prepend"
  }, [_c('el-option', {
    attrs: {
      "label": "餐厅名",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "订单号",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "用户电话",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "search"
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), [_c('el-input-number', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.num1),
      expression: "num1"
    }],
    attrs: {
      "min": 1,
      "max": 10
    },
    domProps: {
      "value": (_vm.num1)
    },
    on: {
      "change": _vm.handleChange,
      "input": function($event) {
        _vm.num1 = $event
      }
    }
  })], _vm._v(" "), [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        _vm.value = $event
      }
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value1),
      expression: "value1"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    domProps: {
      "value": (_vm.value1)
    },
    on: {
      "input": function($event) {
        _vm.value1 = $event
      }
    }
  }), _vm._v(" "), _c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value2),
      expression: "value2"
    }],
    attrs: {
      "on-color": "#13ce66",
      "off-color": "#ff4949"
    },
    domProps: {
      "value": (_vm.value2)
    },
    on: {
      "input": function($event) {
        _vm.value2 = $event
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "//jsonplaceholder.typicode.com/posts/",
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    attrs: {
      "size": "tiny"
    },
    domProps: {
      "value": (_vm.dialogVisible)
    },
    on: {
      "input": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("页数较少时的效果")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": 50
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "demonstration"
  }, [_vm._v("大于 7 页时的效果")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": 1000
    }
  })], 1), [_c('el-button', {
    attrs: {
      "plain": true
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("\n    打开消息提示")])], _vm._v(" "), _c('el-row', {
    staticClass: "tac"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h5', [_vm._v("带 icon")]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "2"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("\n导航一\n")]), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("\n 分组一\n")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_vm._v("选项1")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_vm._v("选项2")])], 2), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "分组2"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_vm._v("选项3")])], 1), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1-4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n 选项4\n")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-4-1"
    }
  }, [_vm._v("选项1")])], 2)], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v("导航二")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v("导航三")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h5', [_vm._v("不带 icon")]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": "2",
      "theme": "dark"
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n 导航一\n")]), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "分组一"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_vm._v("选项1")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_vm._v("选项2")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "分组2"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_vm._v("选项3")])], 1), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "1-4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n 选项4\n")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-4-1"
    }
  }, [_vm._v("选项1")])], 2)], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("导航二")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("导航三")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h5', [_vm._v("分组")]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "mode": "vertical",
      "default-active": "1"
    }
  }, [_c('el-menu-item-group', {
    attrs: {
      "title": "分组一"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("导航一")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("导航二")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "分组二"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("导航三")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_c('i', {
    staticClass: "el-icon-message"
  }), _vm._v("导航四")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-steps', {
    attrs: {
      "space": 100,
      "active": _vm.active,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "步骤 1"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "步骤 2"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "步骤 3"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "12px"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-collapse', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeNames),
      expression: "activeNames"
    }],
    domProps: {
      "value": (_vm.activeNames)
    },
    on: {
      "change": _vm.handleChange,
      "input": function($event) {
        _vm.activeNames = $event
      }
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "一致性 Consistency",
      "name": "1"
    }
  }, [_c('div', [_vm._v("与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；")]), _vm._v(" "), _c('div', [_vm._v("在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "反馈 Feedback",
      "name": "2"
    }
  }, [_c('div', [_vm._v("控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；")]), _vm._v(" "), _c('div', [_vm._v("页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "效率 Efficiency",
      "name": "3"
    }
  }, [_c('div', [_vm._v("简化流程：设计简洁直观的操作流程；")]), _vm._v(" "), _c('div', [_vm._v("清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；")]), _vm._v(" "), _c('div', [_vm._v("帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。")])]), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "可控 Controllability",
      "name": "4"
    }
  }, [_c('div', [_vm._v("用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；")]), _vm._v(" "), _c('div', [_vm._v("结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。")])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed3505ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElementComponents.vue
// module id = 155
// module chunks = 0